import { gql } from "@apollo/client";

export const LOGEAR_USUARIO = gql`
  mutation LogearUsuario($username: String!, $password: String!) {
    logearUsuario(username: $username, password: $password) {
      token
    }
  }
`;
